import { Component } from "react"


/*
    Decision — the Hit / Stand / Double / Split panel with live decision
    statistics (percentages), matching the Pragmatic ONE Blackjack layout.
    Also renders the Insurance YES / NO panel.

    Props:
        mode        "decision" | "insurance"
        actions     { hit, stand, double, split, surrender }  (decision mode)
        stats       { counts: { hit, stand, double, split, surrender }, total }
        myChoice    action the player already picked this round (highlight)
        canAct      whether the player may act now
        onDecision  (action) => void
        insuranceChoice  "yes" | "no" | null
        onInsurance (answer) => void
*/
class Decision extends Component {

    /* Percentage for a decision option */
    _percent = key => {
        const { stats } = this.props
        if (!stats || !stats.total) return 0
        return Math.round(((stats.counts && stats.counts[key]) || 0) / stats.total * 100)
    }

    _button = (key, icon, label, className) => {

        const { actions, myChoice, canAct, onDecision } = this.props

        if (actions && actions[key] === false) return null

        /* Once a choice is made: the picked button grows & fades, others fade out */
        const chosen = !!myChoice
        const anim = chosen ? (myChoice === key ? "picked" : "dismiss") : ""
        const disabled = !canAct

        return (
            <div className="bj-decision-cell">
                <div
                    className={`bj-decision-btn bj-decision-${className} ${anim} ${disabled ? "disabled" : ""}`}
                    onClick={() => { if (canAct && !chosen) onDecision(key) }}
                >
                    <span className="bj-decision-icon">{icon}</span>
                    <span className="bj-decision-label">{label}</span>
                </div>
                <div className="bj-decision-percent">{this._percent(key)}%</div>
            </div>
        )
    }

    _decision = () => (
        <div className={`bj-decision ${this.props.myChoice ? "chosen" : ""}`}>
            {this._button("surrender", "⚑", "SURRENDER", "surrender")}
            {this._button("double", "2×", "DOUBLE", "double")}
            {this._button("hit", "+", "HIT", "hit")}
            {this._button("stand", "−", "STAND", "stand")}
            {this._button("split", "◀▶", "SPLIT", "split")}
        </div>
    )

    /* Shield icon — check (yes) or cross (no), coloured like its circle */
    _shield = (yes) => (
        <svg viewBox="0 0 32 38" className="bj-shield" aria-hidden="true">
            <path d="M16 2 L30 7 V18 C30 27 24 33 16 36 C8 33 2 27 2 18 V7 Z" fill="#fff" />
            {yes
                ? <path d="M10 19 l4 4 8-9" fill="none" stroke="#c9a636" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
                : <path d="M11 13 l10 12 M21 13 l-10 12" fill="none" stroke="#c0392b" strokeWidth="3.4" strokeLinecap="round" />
            }
        </svg>
    )

    _insurance = () => {

        const { insuranceChoice, onInsurance } = this.props

        /* Once picked: the chosen circle grows & fades, the other fades out —
           same behaviour as the decision buttons (no waiting for the timer) */
        const chosen = !!insuranceChoice
        const anim = key => chosen ? (insuranceChoice === key ? "picked" : "dismiss") : ""

        return (
            <div className={`bj-insurance ${chosen ? "chosen" : ""}`}>
                <div className="bj-insurance-title">Страховка?</div>
                <div className="bj-insurance-buttons">
                    <div className="bj-insurance-opt">
                        <div
                            className={`bj-insurance-circle yes ${anim("yes")}`}
                            onClick={() => { if (!chosen) onInsurance("yes") }}
                        >
                            {this._shield(true)}
                        </div>
                        <div className="bj-insurance-label">ДА</div>
                    </div>
                    <div className="bj-insurance-opt">
                        <div
                            className={`bj-insurance-circle no ${anim("no")}`}
                            onClick={() => { if (!chosen) onInsurance("no") }}
                        >
                            {this._shield(false)}
                        </div>
                        <div className="bj-insurance-label">НЕТ</div>
                    </div>
                </div>
            </div>
        )
    }

    /* EVEN MONEY YES / NO — offered when the player has a blackjack and the
       dealer shows an Ace. Reuses the bj-insurance panel styling. */
    _evenMoney = () => {

        const { evenMoneyChoice, onEvenMoney } = this.props

        const chosen = !!evenMoneyChoice
        const anim = key => chosen ? (evenMoneyChoice === key ? "picked" : "dismiss") : ""

        return (
            <div className={`bj-insurance ${chosen ? "chosen" : ""}`}>
                <div className="bj-insurance-title">EVEN MONEY (Равные деньги)?</div>
                <div className="bj-insurance-buttons">
                    <div className="bj-insurance-opt">
                        <div
                            className={`bj-insurance-circle yes ${anim("yes")}`}
                            onClick={() => { if (!chosen) onEvenMoney("yes") }}
                        >
                            {this._shield(true)}
                        </div>
                        <div className="bj-insurance-label">ДА</div>
                    </div>
                    <div className="bj-insurance-opt">
                        <div
                            className={`bj-insurance-circle no ${anim("no")}`}
                            onClick={() => { if (!chosen) onEvenMoney("no") }}
                        >
                            {this._shield(false)}
                        </div>
                        <div className="bj-insurance-label">НЕТ</div>
                    </div>
                </div>
            </div>
        )
    }

    render = () => {
        const { mode } = this.props
        if (mode === "insurance") return this._insurance()
        if (mode === "evenmoney") return this._evenMoney()
        return this._decision()
    }
}

export default Decision
